import axios from "axios";
import { endpoints } from "../config/api";
import { getAuthHeaders } from "./getAuthHeaders";
import { flattenIndustryIndex } from "../lib/industryFilter";

const CACHE_TTL_MS = 20 * 60 * 1000;
let cache = { fetchedAt: 0, sectors: null, flattened: null };

function unwrapSectors(payload) {
  if (!payload) return [];
  if (Array.isArray(payload.sectors)) return payload.sectors;
  if (payload.data?.sectors) return payload.data.sectors;
  if (Array.isArray(payload.data)) return payload.data;
  return [];
}

export async function fetchSectorIndustryList({ forceRefresh = false } = {}) {
  const now = Date.now();
  if (
    !forceRefresh &&
    cache.sectors &&
    now - cache.fetchedAt < CACHE_TTL_MS
  ) {
    return { sectors: cache.sectors, flattened: cache.flattened };
  }

  const response = await axios.get(endpoints.stockSectorIndustryList, {
    headers: { ...getAuthHeaders() },
  });
  const sectors = unwrapSectors(response.data);
  const flattened = flattenIndustryIndex(sectors);
  cache = { fetchedAt: now, sectors, flattened };
  return { sectors, flattened };
}

export function clearSectorIndustryCache() {
  cache = { fetchedAt: 0, sectors: null, flattened: null };
}
